module.exports = __webpack_public_path__ + "static/media/Dual_8500.94f2fc6a.jpg";